import mock from '@/@fake-db/mock'
import { paginateArray, sortCompare } from '@/@fake-db/utils'

/* eslint-disable global-require */
const data = {
  users: [
    {
      id: 1,
      fullName: 'Galen Slixby',
      company: 'Yotz PVT LTD',
      owner: 'james paul',
      Email: 'gslixby0',
      country: 'El Salvador',
      contact: '(479) 232-9151',
      Email: 'gslixby0@abc.net.au',
      EmailConfirmation: true,
      status: 'inactive',
      avatar: '',
    },
    {
      id: 2,
      fullName: 'Halsey Redmore',
      company: 'Skinder PVT LTD',
      owner: 'author',
      Email: 'hredmore1',
      country: 'Albania',
      contact: '(472) 607-9137',
      Email: 'hredmore1@imgur.com',
      EmailConfirmation: true,
      status: 'pending',
      avatar: require('@/assets/images/avatars/10.png'),
    },
    {
      id: 3,
      fullName: 'Marjory Sicely',
      company: 'Oozz PVT LTD',
      owner: 'maintainer',
      Email: 'msicely2',
      country: 'Russia',
      contact: '(321) 264-4599',
      Email: 'msicely2@who.int',
      EmailConfirmation: true,
      status: 'active',
      avatar: require('@/assets/images/avatars/1.png'),
    },
    {
      id: 4,
      fullName: 'Cyrill Risby',
      company: 'Oozz PVT LTD',
      owner: 'maintainer',
      Email: 'crisby3',
      country: 'China',
      contact: '(923) 690-6806',
      Email: 'crisby3@wordpress.com',
      EmailConfirmation: true,
      status: 'inactive',
      avatar: require('@/assets/images/avatars/9.png'),
    },
    {
      id: 5,
      fullName: 'Maggy Hurran',
      company: 'Aimbo PVT LTD',
      owner: 'subscriber',
      Email: 'mhurran4',
      country: 'Pakistan',
      contact: '(669) 914-1078',
      Email: 'mhurran4@yahoo.co.jp',
      EmailConfirmation: true,
      status: 'pending',
      avatar: require('@/assets/images/avatars/10.png'),
    },
    {
      id: 6,
      fullName: 'Silvain Halstead',
      company: 'Jaxbean PVT LTD',
      owner: 'author',
      Email: 'shalstead5',
      country: 'China',
      contact: '(958) 973-3093',
      Email: 'shalstead5@shinystat.com',
      EmailConfirmation: true,
      status: 'active',
      avatar: '',
    },
    {
      id: 7,
      fullName: 'Breena Gallemore',
      company: 'Jazzy PVT LTD',
      owner: 'subscriber',
      Email: 'bgallemore6',
      country: 'Canada',
      contact: '(825) 977-8152',
      Email: 'bgallemore6@boston.com',
      EmailConfirmation: true,
      status: 'pending',
      avatar: '',
    },
    {
      id: 8,
      fullName: 'Kathryne Liger',
      company: 'Pixoboo PVT LTD',
      owner: 'author',
      Email: 'kliger7',
      country: 'France',
      contact: '(187) 440-0934',
      Email: 'kliger7@vinaora.com',
      EmailConfirmation: true,
      status: 'pending',
      avatar: require('@/assets/images/avatars/9.png'),
    },
    {
      id: 9,
      fullName: 'Franz Scotfurth',
      company: 'Tekfly PVT LTD',
      owner: 'subscriber',
      Email: 'fscotfurth8',
      country: 'China',
      contact: '(978) 146-5443',
      Email: 'fscotfurth8@dailymotion.com',
      EmailConfirmation: true,
      status: 'pending',
      avatar: require('@/assets/images/avatars/2.png'),
    },
    {
      id: 10,
      fullName: 'Jillene Bellany',
      company: 'Gigashots PVT LTD',
      owner: 'maintainer',
      Email: 'jbellany9',
      country: 'Jamaica',
      contact: '(589) 284-6732',
      Email: 'jbellany9@kickstarter.com',
      EmailConfirmation: true,
      status: 'inactive',
      avatar: require('@/assets/images/avatars/9.png'),
    },
    {
      id: 11,
      fullName: 'Jonah Wharlton',
      company: 'Eare PVT LTD',
      owner: 'subscriber',
      Email: 'jwharltona',
      country: 'Mauritius',
      contact: '(176) 532-6824',
      Email: 'jwharltona@oakley.com',
      EmailConfirmation: true,
      status: 'inactive',
      avatar: require('@/assets/images/avatars/4.png'),
    },
    {
      id: 12,
      fullName: 'Seth Hallam',
      company: 'Yakitri PVT LTD',
      owner: 'subscriber',
      Email: 'shallamb',
      country: 'Peru',
      contact: '(234) 464-0600',
      Email: 'shallamb@hugedomains.com',
      EmailConfirmation: true,
      status: 'pending',
      avatar: require('@/assets/images/avatars/5.png'),
    },
    {
      id: 13,
      fullName: 'Yoko Pottie',
      company: 'Leenti PVT LTD',
      owner: 'subscriber',
      Email: 'ypottiec',
      country: 'Philippines',
      contact: '(907) 284-5083',
      Email: 'ypottiec@privacy.gov.au',
      EmailConfirmation: true,
      status: 'inactive',
      avatar: require('@/assets/images/avatars/7.png'),
    },
    {
      id: 14,
      fullName: 'Maximilianus Krause',
      company: 'Digitube PVT LTD',
      owner: 'author',
      Email: 'mkraused',
      country: 'Democratic Republic of the Congo',
      contact: '(167) 135-7392',
      Email: 'mkraused@stanford.edu',
      EmailConfirmation: true,
      status: 'active',
      avatar: require('@/assets/images/avatars/9.png'),
    },
    {
      id: 15,
      fullName: 'Zsazsa McCleverty',
      company: 'Kaymbo PVT LTD',
      owner: 'maintainer',
      Email: 'zmcclevertye',
      country: 'France',
      contact: '(317) 409-6565',
      Email: 'zmcclevertye@soundcloud.com',
      EmailConfirmation: true,
      status: 'active',
      avatar: require('@/assets/images/avatars/2.png'),
    },
    {
      id: 16,
      fullName: 'Bentlee Emblin',
      company: 'Yambee PVT LTD',
      owner: 'author',
      Email: 'bemblinf',
      country: 'Spain',
      contact: '(590) 606-1056',
      Email: 'bemblinf@wired.com',
      EmailConfirmation: true,
      status: 'active',
      avatar: require('@/assets/images/avatars/6.png'),
    },
    {
      id: 17,
      fullName: 'Brockie Myles',
      company: 'Wikivu PVT LTD',
      owner: 'maintainer',
      Email: 'bmylesg',
      country: 'Poland',
      contact: '(553) 225-9905',
      Email: 'bmylesg@amazon.com',
      EmailConfirmation: true,
      status: 'active',
      avatar: '',
    },
    {
      id: 18,
      fullName: 'Bertha Biner',
      company: 'Twinte PVT LTD',
      owner: 'james paul',
      Email: 'bbinerh',
      country: 'Yemen',
      contact: '(901) 916-9287',
      Email: 'bbinerh@mozilla.com',
      EmailConfirmation: true,
      status: 'active',
      avatar: require('@/assets/images/avatars/7.png'),
    },
    {
      id: 19,
      fullName: 'Travus Bruntjen',
      company: 'Cogidoo PVT LTD',
      owner: 'admin',
      Email: 'tbruntjeni',
      country: 'France',
      contact: '(524) 586-6057',
      Email: 'tbruntjeni@sitemeter.com',
      EmailConfirmation: true,
      status: 'active',
      avatar: '',
    },
    {
      id: 20,
      fullName: 'Wesley Burland',
      company: 'Bubblemix PVT LTD',
      owner: 'james paul',
      Email: 'wburlandj',
      country: 'Honduras',
      contact: '(569) 683-1292',
      Email: 'wburlandj@uiuc.edu',
      EmailConfirmation: true,
      status: 'inactive',
      avatar: require('@/assets/images/avatars/6.png'),
    },
    {
      id: 21,
      fullName: 'Selina Kyle',
      company: 'Wayne Enterprises',
      owner: 'admin',
      Email: 'catwomen1940',
      country: 'USA',
      contact: '(829) 537-0057',
      Email: 'irena.dubrovna@wayne.com',
      EmailConfirmation: true,
      status: 'active',
      avatar: require('@/assets/images/avatars/1.png'),
    },
    {
      id: 22,
      fullName: 'Jameson Lyster',
      company: 'Quaxo PVT LTD',
      owner: 'james paul',
      Email: 'jlysterl',
      country: 'Ukraine',
      contact: '(593) 624-0222',
      Email: 'jlysterl@guardian.co.uk',
      EmailConfirmation: true,
      status: 'inactive',
      avatar: require('@/assets/images/avatars/8.png'),
    },
    {
      id: 23,
      fullName: 'Kare Skitterel',
      company: 'Ainyx PVT LTD',
      owner: 'maintainer',
      Email: 'kskitterelm',
      country: 'Poland',
      contact: '(254) 845-4107',
      Email: 'kskitterelm@washingtonpost.com',
      EmailConfirmation: true,
      status: 'pending',
      avatar: require('@/assets/images/avatars/3.png'),
    },
    {
      id: 24,
      fullName: 'Cleavland Hatherleigh',
      company: 'Flipopia PVT LTD',
      owner: 'admin',
      Email: 'chatherleighn',
      country: 'Brazil',
      contact: '(700) 783-7498',
      Email: 'chatherleighn@washington.edu',
      EmailConfirmation: true,
      status: 'pending',
      avatar: require('@/assets/images/avatars/2.png'),
    },
    {
      id: 25,
      fullName: 'Adeline Micco',
      company: 'Topicware PVT LTD',
      owner: 'admin',
      Email: 'amiccoo',
      country: 'France',
      contact: '(227) 598-1841',
      Email: 'amiccoo@whitehouse.gov',
      EmailConfirmation: true,
      status: 'pending',
      avatar: '',
    },
    {
      id: 26,
      fullName: 'Hugh Hasson',
      company: 'Skinix PVT LTD',
      owner: 'admin',
      Email: 'hhassonp',
      country: 'China',
      contact: '(582) 516-1324',
      Email: 'hhassonp@bizjournals.com',
      EmailConfirmation: true,
      status: 'inactive',
      avatar: require('@/assets/images/avatars/4.png'),
    },
    {
      id: 27,
      fullName: 'Germain Jacombs',
      company: 'Youopia PVT LTD',
      owner: 'james paul',
      Email: 'gjacombsq',
      country: 'Zambia',
      contact: '(137) 467-5393',
      Email: 'gjacombsq@jigsy.com',
      EmailConfirmation: true,
      status: 'active',
      avatar: require('@/assets/images/avatars/10.png'),
    },
    {
      id: 28,
      fullName: 'Bree Kilday',
      company: 'Jetpulse PVT LTD',
      owner: 'maintainer',
      Email: 'bkildayr',
      country: 'Portugal',
      contact: '(412) 476-0854',
      Email: 'bkildayr@mashable.com',
      EmailConfirmation: true,
      status: 'active',
      avatar: '',
    },
    {
      id: 29,
      fullName: 'Candice Pinyon',
      company: 'Kare PVT LTD',
      owner: 'maintainer',
      Email: 'cpinyons',
      country: 'Sweden',
      contact: '(170) 683-1520',
      Email: 'cpinyons@behance.net',
      EmailConfirmation: true,
      status: 'active',
      avatar: require('@/assets/images/avatars/7.png'),
    },
    {
      id: 30,
      fullName: 'Isabel Mallindine',
      company: 'Voomm PVT LTD',
      owner: 'subscriber',
      Email: 'imallindinet',
      country: 'Slovenia',
      contact: '(332) 803-1983',
      Email: 'imallindinet@shinystat.com',
      EmailConfirmation: true,
      status: 'pending',
      avatar: '',
    },
    {
      id: 31,
      fullName: 'Gwendolyn Meineken',
      company: 'Oyondu PVT LTD',
      owner: 'admin',
      Email: 'gmeinekenu',
      country: 'Moldova',
      contact: '(551) 379-7460',
      Email: 'gmeinekenu@hc360.com',
      EmailConfirmation: true,
      status: 'pending',
      avatar: require('@/assets/images/avatars/1.png'),
    },
    {
      id: 32,
      fullName: 'Rafaellle Snowball',
      company: 'Fivespan PVT LTD',
      owner: 'james paul',
      Email: 'rsnowballv',
      country: 'Philippines',
      contact: '(974) 829-0911',
      Email: 'rsnowballv@indiegogo.com',
      EmailConfirmation: true,
      status: 'pending',
      avatar: require('@/assets/images/avatars/5.png'),
    },
    {
      id: 33,
      fullName: 'Rochette Emer',
      company: 'Thoughtworks PVT LTD',
      owner: 'admin',
      Email: 'remerw',
      country: 'North Korea',
      contact: '(841) 889-3339',
      Email: 'remerw@blogtalkradio.com',
      EmailConfirmation: true,
      status: 'active',
      avatar: require('@/assets/images/avatars/8.png'),
    },
    {
      id: 34,
      fullName: 'Ophelie Fibbens',
      company: 'Jaxbean PVT LTD',
      owner: 'subscriber',
      Email: 'ofibbensx',
      country: 'Indonesia',
      contact: '(764) 885-7351',
      Email: 'ofibbensx@booking.com',
      EmailConfirmation: true,
      status: 'active',
      avatar: require('@/assets/images/avatars/4.png'),
    },
    {
      id: 35,
      fullName: 'Stephen MacGilfoyle',
      company: 'Browseblab PVT LTD',
      owner: 'maintainer',
      Email: 'smacgilfoyley',
      country: 'Japan',
      contact: '(350) 589-8520',
      Email: 'smacgilfoyley@bigcartel.com',
      EmailConfirmation: true,
      status: 'pending',
      avatar: '',
    },
    {
      id: 36,
      fullName: 'Bradan Rosebotham',
      company: 'Agivu PVT LTD',
      owner: 'subscriber',
      Email: 'brosebothamz',
      country: 'Belarus',
      contact: '(882) 933-2180',
      Email: 'brosebothamz@tripadvisor.com',
      EmailConfirmation: true,
      status: 'inactive',
      avatar: '',
    },
    {
      id: 37,
      fullName: 'Skip Hebblethwaite',
      company: 'Katz PVT LTD',
      owner: 'admin',
      Email: 'shebblethwaite10',
      country: 'Canada',
      contact: '(610) 343-1024',
      Email: 'shebblethwaite10@arizona.edu',
      EmailConfirmation: true,
      status: 'inactive',
      avatar: require('@/assets/images/avatars/9.png'),
    },
    {
      id: 38,
      fullName: 'Moritz Piccard',
      company: 'Twitternation PVT LTD',
      owner: 'maintainer',
      Email: 'mpiccard11',
      country: 'Croatia',
      contact: '(365) 277-2986',
      Email: 'mpiccard11@vimeo.com',
      EmailConfirmation: true,
      status: 'inactive',
      avatar: require('@/assets/images/avatars/1.png'),
    },
    {
      id: 39,
      fullName: 'Tyne Widmore',
      company: 'Yombu PVT LTD',
      owner: 'subscriber',
      Email: 'twidmore12',
      country: 'Finland',
      contact: '(531) 731-0928',
      Email: 'twidmore12@bravesites.com',
      EmailConfirmation: true,
      status: 'pending',
      avatar: '',
    },
    {
      id: 40,
      fullName: 'Florenza Desporte',
      company: 'Kamba PVT LTD',
      owner: 'author',
      Email: 'fdesporte13',
      country: 'Ukraine',
      contact: '(312) 104-2638',
      Email: 'fdesporte13@omniture.com',
      EmailConfirmation: true,
      status: 'active',
      avatar: require('@/assets/images/avatars/6.png'),
    },
    {
      id: 41,
      fullName: 'Edwina Baldetti',
      company: 'Dazzlesphere PVT LTD',
      owner: 'maintainer',
      Email: 'ebaldetti14',
      country: 'Haiti',
      contact: '(315) 329-3578',
      Email: 'ebaldetti14@theguardian.com',
      EmailConfirmation: true,
      status: 'pending',
      avatar: '',
    },
    {
      id: 42,
      fullName: 'Benedetto Rossiter',
      company: 'Mybuzz PVT LTD',
      owner: 'james paul',
      Email: 'brossiter15',
      country: 'Indonesia',
      contact: '(323) 175-6741',
      Email: 'brossiter15@craigslist.org',
      EmailConfirmation: true,
      status: 'inactive',
      avatar: '',
    },
    {
      id: 43,
      fullName: 'Micaela McNirlan',
      company: 'Tambee PVT LTD',
      owner: 'admin',
      Email: 'mmcnirlan16',
      country: 'Indonesia',
      contact: '(242) 952-0916',
      Email: 'mmcnirlan16@hc360.com',
      EmailConfirmation: true,
      status: 'inactive',
      avatar: '',
    },
    {
      id: 44,
      fullName: 'Vladamir Koschek',
      company: 'Centimia PVT LTD',
      owner: 'author',
      Email: 'vkoschek17',
      country: 'Guatemala',
      contact: '(531) 758-8335',
      Email: 'vkoschek17@abc.net.au',
      EmailConfirmation: true,
      status: 'active',
      avatar: '',
    },
    {
      id: 45,
      fullName: 'Corrie Perot',
      company: 'Flipopia PVT LTD',
      owner: 'subscriber',
      Email: 'cperot18',
      country: 'China',
      contact: '(659) 385-6808',
      Email: 'cperot18@goo.ne.jp',
      EmailConfirmation: true,
      status: 'pending',
      avatar: require('@/assets/images/avatars/3.png'),
    },
    {
      id: 46,
      fullName: 'Saunder Offner',
      company: 'Skalith PVT LTD',
      owner: 'maintainer',
      Email: 'soffner19',
      country: 'Poland',
      contact: '(200) 586-2264',
      Email: 'soffner19@mac.com',
      EmailConfirmation: true,
      status: 'pending',
      avatar: '',
    },
    {
      id: 47,
      fullName: 'Karena Courtliff',
      company: 'Feedfire PVT LTD',
      owner: 'admin',
      Email: 'kcourtliff1a',
      country: 'China',
      contact: '(478) 199-0020',
      Email: 'kcourtliff1a@bbc.co.uk',
      EmailConfirmation: true,
      status: 'active',
      avatar: require('@/assets/images/avatars/1.png'),
    },
    {
      id: 48,
      fullName: 'Onfre Wind',
      company: 'Thoughtmix PVT LTD',
      owner: 'admin',
      Email: 'owind1b',
      country: 'Ukraine',
      contact: '(344) 262-7270',
      Email: 'owind1b@yandex.ru',
      EmailConfirmation: true,
      status: 'pending',
      avatar: '',
    },
    {
      id: 49,
      fullName: 'Paulie Durber',
      company: 'Babbleblab PVT LTD',
      owner: 'subscriber',
      Email: 'pdurber1c',
      country: 'Sweden',
      contact: '(694) 676-1275',
      Email: 'pdurber1c@gov.uk',
      EmailConfirmation: true,
      status: 'inactive',
      avatar: '',
    },
    {
      id: 50,
      fullName: 'Beverlie Krabbe',
      company: 'Kaymbo PVT LTD',
      owner: 'james paul',
      Email: 'bkrabbe1d',
      EmailConfirmation: true,
      country: 'China',
      contact: '(397) 294-5153',
      Email: 'bkrabbe1d@home.pl',
      EmailConfirmation: true,
      status: 'active',
      avatar: require('@/assets/images/avatars/9.png'),
    },
  ],
}
/* eslint-enable */

// ------------------------------------------------
// GET: Return Users
// ------------------------------------------------
mock.onGet('/apps/userRole/users').reply(config => {
  // eslint-disable-next-line object-curly-newline
  const {
    q = '',
    perPage = 10,
    page = 1,
    sortBy = 'id',
    sortDesc = false,
    owner = null,
    plan = null,
    status = null,
  } = config.params
  /* eslint-enable */

  const queryLowered = q.toLowerCase()
  const filteredData = data.users.filter(
    user =>
      /* eslint-disable operator-linebreak, implicit-arrow-linebreak */
      (user.Email.toLowerCase().includes(queryLowered) || user.fullName.toLowerCase().includes(queryLowered)) &&
      user.owner === (owner || user.owner) &&
      user.currentPlan === (plan || user.currentPlan) &&
      user.status === (status || user.status),
  )
  /* eslint-enable  */

  const sortedData = filteredData.sort(sortCompare(sortBy))
  if (sortDesc) sortedData.reverse()

  return [
    200,
    {
      users: paginateArray(sortedData, perPage, page),
      total: filteredData.length,
    },
  ]
})

// ------------------------------------------------
// POST: Add new user
// ------------------------------------------------
mock.onPost('/apps/userRole/users').reply(config => {
  // Get event from post data
  const { user } = JSON.parse(config.data)

  // Assign Status
  user.status = 'active'

  const { length } = data.users
  let lastIndex = 0
  if (length) {
    lastIndex = data.users[length - 1].id
  }
  user.id = lastIndex + 1

  data.users.push(user)

  return [201, { user }]
})

// ------------------------------------------------
// GET: Return Single User
// ------------------------------------------------
mock.onGet(/\/apps\/userRole\/users\/\d+/).reply(config => {
  // Get event id from URL
  let userId = config.url.substring(config.url.lastIndexOf('/') + 1)

  // Convert Id to number
  userId = Number(userId)

  const userIndex = data.users.findIndex(e => e.id === userId)
  const user = data.users[userIndex]

  if (user) return [200, user]
  return [404]
})
